import { useTranslation } from 'react-i18next'

import { IACL, TeamMemberRole } from '@makyoapp/makyo-sdk/models/ACL'
import { Admin16, Editor16, Viewer16 } from '@makyoapp/makyo-icon/icon'
import { CheckboxTable } from '@makyoapp/makyo-ui'

import useACLTeam from './hooks/useACLTeam'

/*
const DEFAULT_TEAM_ACL: ACLValues[] = [
  {
    label: 'Database',
    icon: <Db16 />,
    checks: {
      viewDbTablesRecords: [
        MemberRole.Admin,
        MemberRole.Editor,
        MemberRole.Viewer
      ],
      editDbTables: [MemberRole.Admin, MemberRole.Editor],
      deleteDbTables: [MemberRole.Admin],
      editRecords: [MemberRole.Admin, MemberRole.Editor],
      deleteRecords: [MemberRole.Admin, MemberRole.Editor],
      editColumns: [MemberRole.Admin, MemberRole.Editor],
      deleteColumns: [MemberRole.Admin, MemberRole.Editor]
    }
  },
  {
    label: 'Apps',
    icon: <App16 />,
    checks: {
      appBuilder: [MemberRole.Admin, MemberRole.Editor, MemberRole.Viewer],
      viewAppData: [MemberRole.Admin, MemberRole.Editor, MemberRole.Viewer],
      linkDb: [MemberRole.Admin, MemberRole.Editor],
      changePlan: [MemberRole.Admin],
      editAppInfo: [MemberRole.Admin, MemberRole.Editor],
      changeDomain: [MemberRole.Admin],
      managePlugins: [MemberRole.Admin],
      managers: [MemberRole.Admin, MemberRole.Editor],
      privacy: [MemberRole.Admin],
      delete: [],
      viewIndividualApp: []
    }
  }
]
*/

/**
 * OrgDetailACLForTeam is a component that renders a table with checkboxes
 * for different roles (Admin, Editor, Viewer) in a team.
 * It uses the `rules` prop to determine which checkboxes should be checked.
 * When a checkbox is checked or unchecked, it calls the `setIsSaved` function.
 *
 * @param {object} props The props to pass into the component.
 * @param {IACL} props.rules The Access Control List rules.
 * @param {function} props.setIsSaved Function to set the `isSaved` state.
 *
 * @returns {JSX.Element} The rendered component.
 */
export default function OrgDetailACLForTeam({
  rules,
  setIsSaved,
}: {
  rules: IACL
  setIsSaved: (saved: boolean) => void
}) {
  const { t } = useTranslation()
  const { values, canEditACL, handleCheck } = useACLTeam(rules, setIsSaved)

  return (
    <CheckboxTable
      keys={[
        {
          id: TeamMemberRole.Admin,
          icon: <Admin16 />,
          label: t('Team Admin'),
        },
        {
          id: TeamMemberRole.Editor,
          icon: <Editor16 />,
          label: t('Editor'),
        },
        {
          id: TeamMemberRole.Viewer,
          icon: <Viewer16 />,
          label: t('Viewer'),
        },
      ]}
      //itemSpan={(span) => span + 1}
      //beforeRowTh={<CTRowTh label={t('Owner')} icon={<Shield16 />} />}
      /*afterCellTitle={
        <td>
          <Checkbox checked disabled justify={JustifyVariant.Center} />
        </td>
      }*/
      canEdit={canEditACL}
      values={values}
      renderLabel={(label) => {
        return t(label)
      }}
      onClick={handleCheck}
    />
  )
}
